import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { noop } from 'lodash-es';
import { useOverlayContext } from 'seagull';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useLocaleKeys } from '~/i18n';
import { useStoreActions } from '~/store/store-context';
import { ImportClientsModal } from '../ImportClientsModal/ImportClientsModal';
import { blockingErrorKindFrom } from './useOpenImportClientsModal.utils';
export const IMPORT_CLIENTS_SERVER_ERROR_TOAST_TESTID = 'import-clients-server-error-toast';
export function useOpenImportClientsModal() {
    let { onExportClients = noop } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { showModal, showErrorToast } = useOverlayContext();
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { t: importTexts } = useLocaleKeys('pages.importClients');
    return useCallback(()=>showModal({
            biName: 'import_clients',
            openBottomSheetOnMobile: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ImportClientsModal, {
                    dismissModal: dismissModal,
                    onExportClients: onExportClients,
                    onSubmit: async (file)=>{
                        try {
                            const response = await api.client.bulkImport(file);
                            void queryClient.invalidateQueries({
                                queryKey: [
                                    QueryKeys.Clients
                                ]
                            });
                            void queryClient.invalidateQueries({
                                queryKey: [
                                    QueryKeys.ClientContacts
                                ]
                            });
                            void queryClient.invalidateQueries({
                                queryKey: [
                                    QueryKeys.Contacts
                                ]
                            });
                            return {
                                kind: 'result',
                                response
                            };
                        } catch (e) {
                            const errorKind = blockingErrorKindFrom(e);
                            if (errorKind != null) return {
                                kind: 'blockingError',
                                errorKind
                            };
                            showErrorToast(importTexts.serverErrorToast(), IMPORT_CLIENTS_SERVER_ERROR_TOAST_TESTID);
                            return {
                                kind: 'upload'
                            };
                        }
                    }
                });
            }
        }), [
        api.client,
        queryClient,
        onExportClients
    ]);
}
